// Realtime (WebSocket) redux actions.
//
// The realtime saga owns the single WebSocket connection (via the
// realtime/wsClient singleton). The rest of the app interacts with it through
// these actions:
//   * CONNECT / DISCONNECT  — lifecycle (dispatched at login / logout).
//   * SUBSCRIBE / UNSUBSCRIBE — subscribe to an arbitrary channel string.
//   * SUBSCRIBE_WORKSPACE / UNSUBSCRIBE_WORKSPACE — convenience for the active
//     workspace channel (the saga handles swapping when the workspace changes).
//   * STATUS — connection status for UI indicators.
//   * EVENT  — a server-pushed event; feature reducers/sagas can react to it
//     (channel + event + data) without coupling to the transport.

const ns = 'REALTIME';

export const REALTIME_CONNECT    = ns + '_CONNECT';
export const REALTIME_DISCONNECT = ns + '_DISCONNECT';
export const REALTIME_STATUS     = ns + '_STATUS';

export const REALTIME_SUBSCRIBE   = ns + '_SUBSCRIBE';
export const REALTIME_UNSUBSCRIBE = ns + '_UNSUBSCRIBE';

export const REALTIME_SUBSCRIBE_WORKSPACE   = ns + '_SUBSCRIBE_WORKSPACE';
export const REALTIME_UNSUBSCRIBE_WORKSPACE = ns + '_UNSUBSCRIBE_WORKSPACE';

export const REALTIME_EVENT = ns + '_EVENT';

export const realtimeConnect    = ()        => ({ type: REALTIME_CONNECT });
export const realtimeDisconnect = ()        => ({ type: REALTIME_DISCONNECT });
export const realtimeStatus     = (status)  => ({ type: REALTIME_STATUS, payload: status });

export const realtimeSubscribe   = (channel) => ({ type: REALTIME_SUBSCRIBE,   payload: { channel } });
export const realtimeUnsubscribe = (channel) => ({ type: REALTIME_UNSUBSCRIBE, payload: { channel } });

export const realtimeSubscribeWorkspace   = (workspaceId) => ({ type: REALTIME_SUBSCRIBE_WORKSPACE,   payload: { workspaceId } });
export const realtimeUnsubscribeWorkspace = (workspaceId) => ({ type: REALTIME_UNSUBSCRIBE_WORKSPACE, payload: { workspaceId } });

// Goal channel: a single goal's live stream (run progress, anomaly detected,
// …). Ref-counted, so multiple open goal views are fine; a page subscribes on
// mount and unsubscribes on unmount.
export const realtimeSubscribeGoal   = (goalId) => ({ type: REALTIME_SUBSCRIBE,   payload: { channel: `goal:${goalId}` } });
export const realtimeUnsubscribeGoal = (goalId) => ({ type: REALTIME_UNSUBSCRIBE, payload: { channel: `goal:${goalId}` } });

export const realtimeEvent = (msg) => ({ type: REALTIME_EVENT, payload: msg });
